import constants from "../common/constants";
import axios from "axios";
import api from "../api/api";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import useLogout from "./useLogout";

var URL_PARAM_REPORT = "reportid";

/* #region  Usage Example - To Fold This Region */
// const { validationAttributes, ResetUseValidation, ValidateToken } =
// useAccessValidation();
// useEffect(() => {
//   if (
//     !validationAttributes.loading &&
//     (validationAttributes.response != undefined ||
//       validationAttributes.error != undefined)
//   ) {
//     if (validationAttributes.response != undefined) {
//     }
//     ResetUseValidation();
//     setIsLoaded(true);
//   }
// }, [validationAttributes]);
/* #endregion */

/**
 * Handles Token validation and token error handling (Redirection)
 * @implements Axios validate token
 * @requires JWT Access Token
 * @returns validationAttributes - Response | Error | Loading Status
 */
const useAccessValidation = () => {
  const { handleLogout } = useLogout();

  const [searchParams] = useSearchParams();

  const [validationAttributes, setValidationAttributes] = useState({
    response: undefined,
    error: undefined,
    loading: undefined,
  });

  const axios_ValidateToken = async (token) => {
    var tmpResponse = undefined;
    var tmpError = undefined;

    // jwt config for bearer header.
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    };

    await axios
      .get(api.femsValidateToken, config)
      .then((res) => {
        if (res.status == 200) {
          tmpResponse = res.data;
        } else {
          handleLogout(constants.logout_error_state_error);
        }
      })
      .catch((error) => {
        // Catch errors and navigate to Login Page with Error Messages.
        // UNAUTHORIZED
        if ((error?.response?.status ?? "") === 401) {
          var incidentId = searchParams.get(URL_PARAM_REPORT) ?? "";
          if (incidentId != "") {
            handleLogout(constants.logout_error_state_loginrequired);
          } else {
            handleLogout(constants.logout_error_state_401);
          }
        }
        // INVALID SESSION
        else if ((error?.response?.status ?? "") === 410) {
          handleLogout(constants.logout_error_state_410);
        }
        // OTHER ERRORS
        else {
          handleLogout(constants.logout_error_state_error);
        }
      })
      .finally(() => {
        setValidationAttributes({
          response: tmpResponse,
          error: tmpError,
          loading: false,
        });
      });
  };

  // Executor for Hook
  const ValidateToken = async (token) => {
    setValidationAttributes({ ...validationAttributes, loading: true });
    await axios_ValidateToken(token);
  };

  // Call function for pages with more than one validate token calls
  const ResetUseValidation = () => {
    setValidationAttributes({
      response: undefined,
      error: undefined,
      loading: undefined,
    });
  };

  return {
    validationAttributes,
    ResetUseValidation,
    ValidateToken,
  };
};

export default useAccessValidation;
